import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    add_typo_to_issue,
    add_user_permission_to_issue,
    get_issue_full,
    load_annotations,
    load_issue_observers,
    load_issue_typos,
    loadIssueType_helpdesk,
    remove_issue_observer,
    remove_issue_typos,
    save_annotation,
    update_issue,
} from '../../../utils/services';
import Type_link from './modal/Type_link';
import Modal_proyectos from '../../menus/Modal';
import { Badge, Button, Col, Form, Row } from 'react-bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.css';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import DOMPurify from 'dompurify';
import Team_link from '../crm/modals/Team_link';

/**
 * Panel simplificado para tickets de formación (issue_type = 1).
 * Sin estado abierto/cerrado, sin Remitir a CAS, sin Inventario CAS.
 */
const Training_ticket_panel = ({ permission, token, usr_id, issue_updating_id, onCloseAnnotation }) => {
    const navigate = useNavigate();

    const [canal, setcanal] = useState('');
    const [persona_contacto, setpersona_contacto] = useState('');
    const [email_contacto, setEmail_contacto] = useState('');
    const [telefono_contacto, setTelefono_contacto] = useState('');
    const [direccion_contacto, setDireccion_conctacto] = useState('');
    const [change2Save, setchange2Save] = useState(false);

    const [creator, setCreator] = useState('');
    const [creationDate, setCreationDate] = useState('');
    const [typos, setTypos] = useState([]);
    const [observers, setObservers] = useState([]);
    const [attachedFile, setattachedFile] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [logEntry, setLogEntry] = useState('');
    const [log, setLog] = useState([]);
    const [isModalOpen, setModalOpen] = useState(false);
    const [modal_content, setmodal_content] = useState('');
    const [dropdownOptions, setDropdownOptions] = useState([]);

    useEffect(() => {
        fetch_issueType();
        fetchloadTypology(issue_updating_id);
        fetchload_annotation(issue_updating_id);
        fetchloadObservers();
    }, [token]);

    async function fetch_issueType() {
        const issueTypelist = await loadIssueType_helpdesk(token);
        if (issueTypelist === 'INVALID') {
            navigate('/');
        } else {
            const issueTypeNames = issueTypelist.map((element, index) => ({
                id: element.id,
                name: element.name_issue_type,
                category: element.category,
                index,
            }));
            issueTypeNames.unshift('Seleccione uno...');
            setDropdownOptions(issueTypeNames);
        }
    }

    const modules = {
        toolbar: [
            ['bold', 'italic', 'underline'],
            [{
                color: ['#000000', '#e60000', '#ff9900', '#008a00', '#0066cc', 'gray'],
            }],
        ],
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setattachedFile(file);
        }
    };

    useEffect(() => {
        if (issue_updating_id != null) {
            fetch_full_issue(issue_updating_id);
        }
    }, [issue_updating_id]);

    async function fetch_full_issue(issue_id) {
        const issuefull = await get_issue_full(token, issue_id);
        if (issuefull === 'INVALID') {
            navigate('/');
        } else {
            setpersona_contacto(issuefull['issue_info'][0].persona_contacto);
            setEmail_contacto(issuefull['issue_info'][0].email_contacto);
            setTelefono_contacto(issuefull['issue_info'][0].telefono_contacto);
            setDireccion_conctacto(issuefull['issue_info'][0].direccion_contacto);
            setcanal(issuefull['issue_info'][0].canal);
            setCreator(issuefull['issue_info'][0].creator);
            setCreationDate(issuefull['issue_info'][0].date);
        }
    }

    async function updateAnnotation() {
        const issuefull = await update_issue(
            token,
            issue_updating_id,
            persona_contacto,
            email_contacto,
            telefono_contacto,
            canal,
            direccion_contacto
        );
        if (issuefull === 'INVALID') {
            navigate('/');
        } else {
            setchange2Save(false);
            sendLog('Actualización de información general del ticket', null, 1);
            fetch_full_issue(issue_updating_id);
        }
    }

    const setNewTypoLink = (trello_id) => {
        addTypology(trello_id);
        setModalOpen(false);
    };

    async function addTypology(typo_id) {
        const addUserPerm = await add_typo_to_issue(token, issue_updating_id, typo_id);
        if (addUserPerm === 'INVALID') {
            navigate('/');
        } else {
            fetchloadTypology(issue_updating_id);
        }
    }

    async function fetchloadTypology(issue_id) {
        const typoList = await load_issue_typos(token, issue_id);
        if (typoList === 'INVALID') {
            navigate('/');
        } else {
            const tempTypos = typoList['typos'].map((celement, index) => ({
                link_id: celement.id,
                name_issue_type: celement.name_issue_type,
                type_id: celement.type_id,
                index,
            }));
            setTypos(tempTypos);
        }
    }

    async function onRemoveTypo(link_id) {
        const typoList = await remove_issue_typos(token, link_id);
        if (typoList === 'INVALID') {
            navigate('/');
        } else {
            fetchloadTypology(issue_updating_id);
        }
    }

    async function onRemoveObserver(link_id) {
        const typoList = await remove_issue_observer(token, link_id);
        if (typoList === 'INVALID') {
            navigate('/');
        } else {
            fetchloadObservers(issue_updating_id);
        }
    }

    const getColorForId = (id) => {
        const hue = (id * 41) % 360;
        return `hsl(${hue}, 60%, 50%)`;
    };

    const sendLog = (log_save_text, attachedfile_tosend, type = 0) => {
        if (!log_save_text.trim()) return;
        fetchsave_annotation(log_save_text, attachedfile_tosend, type);
    };

    async function fetchsave_annotation(logMessage, attachedFileFinal, type) {
        setIsSubmitting(true);
        const typoList = await save_annotation(
            token,
            issue_updating_id,
            logMessage,
            usr_id,
            attachedFileFinal,
            type
        );
        if (typoList === 'INVALID') {
            navigate('/');
        } else {
            setLog('');
            setLogEntry('');
            setattachedFile(null);
            fetchload_annotation(issue_updating_id);
            setIsSubmitting(false);
        }
    }

    async function fetchload_annotation(issue_id) {
        const annotationsList = await load_annotations(token, issue_id);
        if (annotationsList === 'INVALID') {
            navigate('/');
        } else if (annotationsList) {
            const templog = annotationsList.map((celement, index) => ({
                id: celement.id,
                issue_date: celement.date_comment,
                description: celement.comment,
                type_name: celement.type_name,
                type: celement.type,
                url_attached:
                    celement.attached_file !== ''
                        ? 'https://team.tomi.la/storage/helpdesk/' +
                          issue_updating_id +
                          '/' +
                          celement.attached_file
                        : '',
                user_by: celement.usr_name,
                index,
            }));
            setLog(templog);
        }
    }

    const setNewMember = (id) => {
        setModalOpen(false);
        addUserPermission(id);
    };

    async function addUserPermission(usr_id_permission) {
        const addUserPerm = await add_user_permission_to_issue(
            token,
            issue_updating_id,
            usr_id_permission
        );
        if (addUserPerm === 'INVALID') {
            navigate('/');
        } else {
            fetchloadObservers(issue_updating_id);
        }
    }

    async function fetchloadObservers() {
        const addObservers = await load_issue_observers(token, issue_updating_id);
        if (addObservers === 'INVALID') {
            navigate('/');
        } else {
            const tempObservers = addObservers['observers'].map((celement, index) => ({
                link_id: celement.id,
                name: celement.usr_name,
                team_usr_id: celement.team_usr_id,
                index,
            }));
            setObservers(tempObservers);
        }
    }

    return (
        <>
            <Modal_proyectos
                isOpen={isModalOpen}
                onClose={() => setModalOpen(false)}
                title={modal_content === 'Type_link' ? 'Agregar Tipologías' : ''}
            >
                {modal_content === 'Team_link' && (
                    <Team_link onSet={(id) => setNewMember(id)} />
                )}
                {modal_content === 'Type_link' && (
                    <Type_link
                        typesOptions={dropdownOptions}
                        onSet={(id, name) => setNewTypoLink(id, name)}
                    />
                )}
            </Modal_proyectos>

            <div className="new-annotation-form p-2 border rounded shadow-sm bg-light">
                <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
                    <button
                        type="button"
                        className="btn btn-light rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                        onClick={onCloseAnnotation}
                        title="Atrás"
                        style={{ width: '36px', height: '36px' }}
                    >
                        <i className="bi bi-arrow-left fs-5"></i>
                    </button>
                    <div className="d-flex flex-wrap align-items-center gap-2 flex-grow-1">
                        <span className="fw-semibold">#{issue_updating_id}</span>
                        <span className="text-muted">·</span>
                        <span className="small text-muted">{creationDate}</span>
                        <span className="text-muted">·</span>
                        <span className="small">{creator}</span>
                        <Badge bg="info">Formación</Badge>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        <Form.Label htmlFor="annotation-channel" className="small mb-0 text-nowrap">
                            Medio:
                        </Form.Label>
                        <select
                            id="annotation-channel"
                            className="form-select form-select-sm"
                            style={{ width: 'auto', minWidth: '130px' }}
                            value={canal}
                            onChange={(e) => {
                                setcanal(e.target.value);
                                setchange2Save(true);
                            }}
                        >
                            <option value="WhatsApp">WhatsApp</option>
                            <option value="Telefonico">Telefónico</option>
                            <option value="Email">Email</option>
                            <option value="Presencial">Presencial</option>
                            <option value="Otro">Otro</option>
                        </select>
                    </div>
                </div>

                <div className="row g-2 mb-2">
                    <div className="col-md-3 col-6">
                        <Form.Label htmlFor="contacto" className="small mb-0">
                            Nombre
                        </Form.Label>
                        <input
                            type="text"
                            id="contacto"
                            className="form-control form-control-sm"
                            value={persona_contacto}
                            onChange={(e) => {
                                setpersona_contacto(e.target.value);
                                setchange2Save(true);
                            }}
                        />
                    </div>
                    <div className="col-md-2 col-6">
                        <Form.Label htmlFor="telefono_contacto" className="small mb-0">
                            Teléfono
                        </Form.Label>
                        <input
                            type="text"
                            id="telefono_contacto"
                            className="form-control form-control-sm"
                            value={telefono_contacto}
                            onChange={(e) => {
                                setTelefono_contacto(e.target.value);
                                setchange2Save(true);
                            }}
                        />
                    </div>
                    <div className="col-md-3 col-6">
                        <Form.Label htmlFor="email_contacto" className="small mb-0">
                            Email
                        </Form.Label>
                        <input
                            type="text"
                            id="email_contacto"
                            className="form-control form-control-sm"
                            value={email_contacto}
                            onChange={(e) => {
                                setEmail_contacto(e.target.value);
                                setchange2Save(true);
                            }}
                        />
                    </div>
                    <div className="col-md-4 col-6">
                        <Form.Label htmlFor="direccion_contacto" className="small mb-0">
                            Dirección
                        </Form.Label>
                        <input
                            type="text"
                            id="direccion_contacto"
                            className="form-control form-control-sm"
                            value={direccion_contacto}
                            onChange={(e) => {
                                setDireccion_conctacto(e.target.value);
                                setchange2Save(true);
                            }}
                        />
                    </div>
                </div>

                <div className="row g-2">
                    <div className="col-md-6">
                        <div className="fw-normal d-flex align-items-center gap-2 flex-wrap">
                            <span className="small text-nowrap">Tipología:</span>
                            <div className="d-flex flex-wrap gap-2 justify-content-lg-end">
                                {typos.map((s) => {
                                    const dynamicColor = getColorForId(parseInt(s.type_id));
                                    return (
                                        <span
                                            key={s.link_id}
                                            className="badge pill chip d-inline-flex align-items-center gap-2 px-3 py-2 fs-8"
                                            style={{
                                                backgroundColor: dynamicColor,
                                                cursor: 'pointer',
                                            }}
                                        >
                                            {s.name_issue_type && s.name_issue_type.length > 25
                                                ? s.name_issue_type.slice(0, 25) + '...'
                                                : s.name_issue_type}
                                            <button
                                                aria-label={`Remove ${s.name_issue_type}`}
                                                className="btn-close btn-close-white btn-close-sm ms-1"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    onRemoveTypo(s.link_id);
                                                }}
                                            />
                                        </span>
                                    );
                                })}
                            </div>
                            <Button
                                variant="outline-dark"
                                size="sm"
                                className="square-btn"
                                onClick={() => {
                                    setmodal_content('Type_link');
                                    setModalOpen(true);
                                }}
                            >
                                +
                            </Button>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="fw-normal d-flex align-items-center gap-2 flex-wrap">
                            <span className="small text-nowrap">Observadores:</span>
                            <div className="d-flex flex-wrap gap-2 justify-content-lg-end">
                                {observers.map((s) => {
                                    const dynamicColor = getColorForId(parseInt(s.team_usr_id));
                                    return (
                                        <span
                                            key={s.link_id}
                                            className="badge pill chip d-inline-flex align-items-center gap-2 px-3 py-2 fs-8"
                                            style={{
                                                backgroundColor: dynamicColor,
                                                cursor: 'pointer',
                                            }}
                                        >
                                            {s.name && s.name.length > 25
                                                ? s.name.slice(0, 25) + '...'
                                                : s.name}
                                            <button
                                                aria-label={`Remove ${s.name}`}
                                                className="btn-close btn-close-white btn-close-sm ms-1"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    onRemoveObserver(s.link_id);
                                                }}
                                            />
                                        </span>
                                    );
                                })}
                            </div>
                            <Button
                                variant="outline-dark"
                                size="sm"
                                className="square-btn"
                                onClick={() => {
                                    setmodal_content('Team_link');
                                    setModalOpen(true);
                                }}
                            >
                                +
                            </Button>
                        </div>
                    </div>
                </div>

                {change2Save ? (
                    <div className="mt-2 d-flex justify-content-end gap-2">
                        <button
                            type="button"
                            className="btn btn-success"
                            onClick={updateAnnotation}
                        >
                            Guardar Anotación
                        </button>
                    </div>
                ) : null}
            </div>

            <Row className="mt-2 text-start">
                <Col>
                    <Form.Label>Seguimiento:</Form.Label>
                    <div style={{ position: 'relative' }}>
                        {isSubmitting && (
                            <div className="loading-overlay">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Enviando...</span>
                                </div>
                            </div>
                        )}
                        <div
                            className={`training-followup-editor mb-2 ${isSubmitting ? 'content-blocked' : ''}`}
                        >
                            <ReactQuill
                                theme="snow"
                                value={logEntry}
                                onChange={setLogEntry}
                                modules={modules}
                                placeholder="El usuario verá la anotación que agregues aquí..."
                            />
                        </div>
                        <div className="d-flex justify-content-end align-items-center gap-2 mb-2">
                            <Button
                                variant="outline-secondary"
                                onClick={() =>
                                    document.getElementById('training-file-upload-input').click()
                                }
                                title="Adjuntar evidencia"
                            >
                                <i className="bi bi-paperclip"></i>
                            </Button>
                            <Form.Control
                                id="training-file-upload-input"
                                type="file"
                                className="d-none"
                                onChange={(e) => handleFileChange(e)}
                            />
                            {attachedFile && (
                                <div className="d-flex align-items-center mt-2 p-2 border rounded">
                                    <span className="me-auto">
                                        <strong>Adjunto:</strong> {attachedFile.name}
                                    </span>
                                    <Button
                                        variant="outline-danger"
                                        size="sm"
                                        onClick={() => setattachedFile(null)}
                                        title="Quitar archivo"
                                    >
                                        <i className="bi bi-x-lg"></i>
                                    </Button>
                                </div>
                            )}
                            <Button
                                variant="primary"
                                onClick={() => sendLog(logEntry, attachedFile)}
                            >
                                {isSubmitting ? 'Enviando...' : 'Enviar ➤'}
                            </Button>
                        </div>
                    </div>

                    <div className="log-box text-left">
                        {log.length === 0 ? (
                            <p className="text-muted fst-italic">
                                No hay entradas en el registro aún.
                            </p>
                        ) : (
                            log.map((l) => (
                                <div
                                    key={l.id}
                                    className={`p-3 rounded mb-3 shadow-sm border ${
                                        parseInt(l.type) != 0
                                            ? 'bg-secondary text-white'
                                            : 'bg-light'
                                    }`}
                                >
                                    <div className="d-flex flex-column flex-sm-row align-items-sm-baseline mb-2 gap-3">
                                        <Badge
                                            bg="warning"
                                            pill
                                            className="chip d-inline-flex align-items-center px-3 py-2 fs-8"
                                        >
                                            {l.user_by}
                                        </Badge>
                                        <span className="text-muted small">
                                            {new Date(l.issue_date).toLocaleString()}
                                        </span>
                                        {l.url_attached !== '' ? (
                                            <a href={l.url_attached} target="_blank" rel="noreferrer">
                                                <i className="bi bi-paperclip"></i>
                                            </a>
                                        ) : null}
                                    </div>
                                    <div
                                        className="lh-sm text-start"
                                        dangerouslySetInnerHTML={{
                                            __html: DOMPurify.sanitize(
                                                l.description.replace(/\r?\n/g, '<br />')
                                            ),
                                        }}
                                    />
                                </div>
                            ))
                        )}
                    </div>
                </Col>
            </Row>
        </>
    );
};

export default Training_ticket_panel;
